'use strict';
/**
 * Общий функционал шаблона
 */
indi.app.blocks.common = function () {
	$('form').garlic();

	var common = this;
	/**
	 * XXX: Признак первичной инициализации (при загрузке документа)
	 *
	 * @var boolean
	 */

	var firstInit = true;
	/**
	 * XXX: Параметры viewport
	 *
	 * @var object
	 */
	var viewport = { 
		width: 0,
		height: 0,
		size: '',
		sizeChanged: false
	};
	/**
	 * XXX: Обработчик изменения размеров окна браузера
	 *
	 * @return void
	 */
	var onWindowResize = function () {
		viewport.width = $(window).width();
		viewport.height = $(window).height();
		var prevSize = viewport.size;
		//Check breakpoints
		if (viewport.width <= 660) {
			viewport.size = 's';
		} else if (viewport.width <= 960) {
			viewport.size = 'm';
		} else {
			viewport.size = 'l';
		}
		viewport.sizeChanged = viewport.size !== prevSize;
	};
	/**
	 * Возвращает параметры viewport
	 *
	 * @return object
	 */
	this.getViewport = function () {
		return viewport;
	};
	/**
	 * XXX: Инициализирует UI в заданном элементе DOM
	 *
	 * @param jQuery domElement DOM element
	 * @return void
	 */
	this.initDOM = function (domElement) {
		if (typeof domElement === 'undefined') {
			domElement = $(document);
		}
		if ($.fn.placeholder) {
			domElement.find('input[placeholder], textarea[placeholder]').placeholder();
		}

		if ($.fn.magnificPopup) {
			domElement.find('.js-mp-image').magnificPopup({
				type: 'image',
				closeOnContentClick: true,
				mainClass: 'mfp-img-mobile',
				image: {
					verticalFit: true
				}
			});
			domElement.find('.js-mp-video').magnificPopup({
				type: 'iframe',
				mainClass: 'mfp-fade',
				removalDelay: 160,
				preloader: false,
				fixedContentPos: false
			});
		}
		if ($.fn.inputmask) {
			domElement.find('input[type="tel"], .js-phone-mask').inputmask('+7 (999) 999-99-99');
			// domElement.find('.js-inn-mask').inputmask('9999999999?99');
			domElement.find('.js-kpp-mask').inputmask('999999999');
			domElement.find('.js-rs-mask').inputmask('999999999999999999999');
			domElement.find('.js-ks-mask').inputmask('99999999999999999999');
			domElement.find('.js-bik-mask').inputmask('99999999999');
			domElement.find('.js-ogrn-mask').inputmask('9999999999999');
			domElement.find('.js-numbers-mask, .js-inn-mask').inputmask('9{*}', {showMaskOnHover: false, showMaskOnFocus: false, placeholder: ''});
			domElement.find('.js-numeric-mask').inputmask({alias: 'numeric', groupSeparator: ' ', autoGroup: true, rightAlign: false, showMaskOnHover: false, showMaskOnFocus: false, placeholder: ''});
			domElement.find('.js-date-mask, .js-datepicker').inputmask('99.99.9999');
			domElement.find('.js-text-mask').on('keyup keydown', function () {
				$(this).val($(this).val().replace(/[^a-zа-я\s\-]?/ig, ''));
			});
		}

		// SelectFix
		if ($.fn.selectFix) {
			domElement.find('select').selectFix(
				{
					'container-max-height': 280,
					'arrow': true,
					'type': 'vertical'
				}
			);

			setTimeout(function(){
				$('.selectfix-container').each(function(){
					var select = $(this).find('select');

					if (select.data('class')) {
						$(this).addClass(select.data('class'));
					}

					if (select.data('search-placeholder')) {
						$(this).find('.selectfix-search input').attr('placeholder', select.data('search-placeholder'));
					}

					if (select.find('option[data-hidden]').length > 0) {
						var indx = 	select.find('option[data-hidden]').index();

						$(this).find('.selectfix-list .selectfix-value[data-index="' + indx + '"]').addClass('hidden');
					}

					$(this).find('.selectfix-current-value').toggleClass('selectfix-placeholder', !select.val().length);
				});

				$(document).on('change', '.selectfix-container select', function() {
					$(this).closest('.selectfix-container').find('.selectfix-current-value').toggleClass('selectfix-placeholder', !$(this).val().length);
				});


				// events
				$('.selectfix-container').on('click', '.selectfix-current-value', function() {
					if ($(this).closest('.selectfix-container').hasClass('opened'))
						$(this).trigger('selectfixOpened');
					else
						$(this).trigger('selectfixClosed');
				});

				$('.selectfix-container').on('change', 'select:not([multiple])', function() {
					$(this).trigger('selectfixClosed');
				});
			}, 100);

			// Select modify mobile off
			var mobileNot = $();
			domElement.on('click', '*', function (event) {
				var mobile = $('.js-mobile.opened');
				if ($(this).closest('.js-mobile').length) {
					mobileNot = mobileNot.add($(this).closest('.js-mobile'));
					//event.stopPropagation();
				}
				mobile = mobile.not(mobileNot);
				mobile.removeClass('opened').trigger('selectfixClosed');
				setTimeout(function () {
					mobileNot = $();
				}, 500);
			});

			// reset
			$(document).on('reset', 'form', function() {
				var form = $(this);

				setTimeout(function() {
					form.find('select').trigger('change');
				}, 1);
			});
		}

		// К форме надо добавить id (произвольный) и класс js-sisyphus.
		// Также в header.php расскоментировать подключение плагина
		if ($.fn.sisyphus) {
			var $formsSisyphus = domElement.find('.js-sisyphus');
			$formsSisyphus.each(function () {
				var id = $(this).attr('id');
				if (id) {
					$('#' + id).sisyphus();
				}
			});
		}
		//Заставляем selectivizr заново обработать DOM при повторных инициализациях
		if (!firstInit && typeof Selectivizr !== 'undefined') {
			Selectivizr.init();
		}
		// Показываем/скрываем пароль в полях форм
		domElement.find('.form .glyphicon-eye-open, .form .glyphicon-eye-close').click(function () {
			var icon = $(this);
			var field = icon.closest('.form-group').find('input');
			if (!icon.data('show-title')) {
				icon.data('show-title', icon.attr('title') || '');
			}
			if (icon.hasClass('glyphicon-eye-open')) {
				field.attr('type', 'text');
				icon
					.removeClass('glyphicon-eye-open')
					.addClass('glyphicon-eye-close')
					.attr('title', icon.data('hide-title'));
			} else {
				field.attr('type', 'password');
				icon
					.removeClass('glyphicon-eye-close')
					.addClass('glyphicon-eye-open')
					.attr('title', icon.data('show-title'));
			}
			return false;
		});
		// для ie - отдельное приглашение
		$(function () {
			$('[autofocus]').focus()
		});

		// // Popover init
		// domElement.find('[data-toggle="popover"]').popover();

		$('.js-calendar-birthdate').datepicker({
			maxDate: "-18y"
		}).inputmask('99.99.9999');

		// Anchor scroll
		domElement.find('.js-anchor').on('click', function () {
			var href = $(this).attr('href');
			$('html, body').animate({
				scrollTop: $(href).offset().top + 'px'
			}, 1000);
			return false;
		});

		// Datepicker icon fix
		domElement.find('.js-date-icon').on('click', function () {
			$(this).next('.date-control__input').trigger('focus');
		});
		domElement.find('.js-date').hover(function () {
				$(this).addClass('hover');
			},
			function () {
				$(this).removeClass('hover');
			}
		);

		// Datepicker active fix
		domElement.find('.date-control__input').on('focus', function () {
			$(this).closest('.date-control').addClass('active');
		}).on('blur', function () {
			$(this).closest('.date-control').removeClass('active');
		});

		// Clear form
		domElement.find('.js-form-clear').on('click', function () {
			$(this).closest('form')[0].reset();
		});

		// Autofocus in modal
		domElement.find('.modal').on('shown.bs.modal', function () {
			var self = $(this);
			setTimeout(function () {
				self.find('form input').eq(0).focus();
			}, 300);
		});

		firstInit = false;
	};
	/**
	 *
	 * Обновление блока по ajax
	 *
	 * @param url ссылка
	 * @param reloadContainerSelector селектор контейнера
	 * @param setIdContainerInHash добавлять ли в url браузера id контейнера
	 */

	common.reloadContainer = function (url, reloadContainerSelector, setIdContainerInHash, skipPush) {
		var $reloadContainer = $(reloadContainerSelector);
		var loading = new indi.ui.loading($reloadContainer);
		var parsedUrl = indi.utils.url.parse(url);
		if (parsedUrl.protocol === "")
			parsedUrl.protocol = window.location.protocol;
		if (parsedUrl.host === "")
			parsedUrl.host = window.location.host;
		if (!$reloadContainer.closest(".main-content").length) {
			if (parsedUrl.query !== "")
				parsedUrl.query += "&";
			parsedUrl.query += "showHead=Y";
		}
		if (!parsedUrl.protocol.match(/:/i)) {
			parsedUrl.protocol += ":";
		}
		url = parsedUrl.protocol + "//" + parsedUrl.host + parsedUrl.pathname;
		if (parsedUrl.query !== "")
			url += "?" + parsedUrl.query;
		if (parsedUrl.hash !== "")
			url += "#" + parsedUrl.hash;
		$.ajax({
			url: url,
			success: function (response) {
				var newContainerHtml = $(response).find(reloadContainerSelector).html();
				$reloadContainer.html(newContainerHtml);
				if ($reloadContainer.find(".js-ajax-pagenation-wrapper").length) {
					$reloadContainer.find(".js-ajax-pagenation-wrapper").remove();
				}
				else {
					$('.js-ajax-pagenation-wrapper[data-container="' + $reloadContainer.attr("id") + '"]').html($(response).find('.js-ajax-pagenation-wrapper[data-container="' + $reloadContainer.attr("id") + '"]').html())
				}
				indi.app.blocks.common.initDOM($reloadContainer);
				indi.app.blocks.popupForm.initDOM($reloadContainer);
				indi.app.blocks.iCounter.initDOM($reloadContainer);
				indi.app.blocks.confirmAction.initDOM($reloadContainer);
				if (setIdContainerInHash === true) {
					url += "#" + $reloadContainer.attr("id");
				}
				if (!skipPush)
					window.history.pushState("", "", url);
				loading.hide();
				$(window).trigger('changepos');
			}
		});
	};
	//Обработчик ресайза окна
	$(window).resize(onWindowResize);
	onWindowResize();
	//Обработчик инициализиации UI
	indi.ui.onInit(this.initDOM, this);
};

/**
 * XXX: Блок Input Validate
 */
indi.app.blocks.inputValidate = function () {

	$('.js-input-validate').closest('form').on('click', '.js-validate-submit', function (e) {
		var ret = false;

		$(this).closest('form').find('.js-input-validate input').each(function () {

			try {
				$(this)[0].setCustomValidity('');
			} catch (ex) {
				console.log(ex);
			}

			if (!($(this)[0].checkValidity())) {
				var ret = true;

				try {
					var validity = $(this).closest('.js-input-validate').data('validate-content');

					if (validity) {
						$(this)[0].setCustomValidity(validity);
					}

					$(this)[0].reportValidity();
				} catch (err) {
					// $(this).closest('.form-group').addClass('has-error');
					$(this).closest('.js-input-validate').popover({placement: 'bottom'});
					$(this).closest('.js-input-validate').popover('show');
				}

				return false;
			}
		});

		if (ret) {
			return false;
		}
	});

	/**
	 * Смена раскладки клавиатуры
	 * @param str
	 * @returns {*}
	 */
	function autoKeyboardLang(str) {
		var s = [
				"й", "ц", "у", "к", "е", "н", "г", "ш", "щ", "з", "х", "ъ",
				"ф", "ы", "в", "а", "п", "р", "о", "л", "д", "ж", "э",
				"я", "ч", "с", "м", "и", "т", "ь", "б", "ю"
			],
			r = [
				"q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "\\[", "\\]",
				"a", "s", "d", "f", "g", "h", "j", "k", "l", ";", "'",
				"z", "x", "c", "v", "b", "n", "m", ",", "\\."
			];

		for (var i = 0; i < r.length; i++) {
			var reg = new RegExp(r[i], 'mig');
			str = str.replace(reg, function (a) {
				return a === a.toLowerCase() ? s[i] : s[i].toUpperCase();
			});
		}

		return str;
	}

	$('.js-input-cyrillic input').keyup(function () {
		if (!indi.ua.isTouchable()) {
			if (!/^[а-яё ]*$/i.test($(this).val())) {
				$(this).val(autoKeyboardLang($(this).val()));
			}
		}
	});
};
/**
 * Проверяет наличие блока Input Validate
 *
 * @return boolean
 */
indi.app.blocks.inputValidate.exists = function () {
	return $('.js-input-validate').length > 0;
};

/**
 * XXX: Блок шаблона "Выбор города"
 */
indi.app.blocks.citySelector = function () {
	// выбираем город
	$('#cities-modal .item a').click(function (e) {

		// получаем соответсвующий элемент инфоблока и записываем в куки
		var city_id = parseInt($(this).data('id'));
		$.get('/local/templates/main/ajax/set-city.php', {'ID': city_id}, function (data) {
			location.href = '/';
		});
		e.preventDefault();
		var cityNow = $('.current-city'),
			cityNew = $(this).text();
		$('#cities-modal .item a').removeClass('active');
		$(this).addClass('active');
		cityNow.text(cityNew);
	});
};
/**
 * Проверяет наличие блока "Выбор города"
 *
 * @return boolean
 */
indi.app.blocks.citySelector.exists = function () {
	return $('.city-selector').length > 0;
};
/**
 * XXX: Блок шаблона "Шапка"
 */
indi.app.blocks.header = function () {
	/* Код блока */
};
/**
 * Проверяет наличие блока "Шапка"
 *
 * @return boolean
 */
indi.app.blocks.header.exists = function () {
	return $('#header').length > 0;
};
/**
 * XXX: Контроллер "Наверх", появляющийся при прокрутке
 */
indi.app.blocks.goTop = function () {
	/**
	 * Базовый DOM элемент
	 *
	 * @var jQuery
	 */
	var block = $('.js-page-top');
	/**
	 * Обработчик прокрутки окна браузера
	 *
	 * @return void
	 */
	var onScroll = function () {
		if ($(document).scrollTop() > $(window).height()) {
			block.addClass('enabled');
		} else {
			block.removeClass('enabled');
		}
	};
	//Обработчик клика по ссылке
	block.find('a').click(function () {
		$('html, body').animate({
			scrollTop: 0
		}, 400);
		return false;
	});
	/* Инициализация */
	$(document).scroll(onScroll);
	onScroll();
};
/**
 * Блок шаблона "Ajax pager"
 */
indi.app.blocks.pager = function () {
	var pager = this;
	/**
	 *
	 * Добавление блока с еще одной страницей по ajax
	 *
	 * @param url ссылка
	 * @param reloadContainerSelector селектор контейнера
	 */

	pager.reloadContainerShowMore = function (url, reloadContainerSelector) {
		var $reloadContainer = $(reloadContainerSelector);
		var loading = new indi.ui.loading($reloadContainer);
		$.ajax({
			url: url,
			success: function (response) {
				var newContainerHtml = $(response).find(reloadContainerSelector).html();
				var $newContainerHtml = $(newContainerHtml);
				if ($reloadContainer.find(".js-ajax-pagenation-wrapper").length) {
					$reloadContainer.find(".js-ajax-pagenation-wrapper").remove();
				}
				else {
					$('.js-ajax-pagenation-wrapper[data-container="' + $reloadContainer.attr("id") + '"]').html($(response).find('.js-ajax-pagenation-wrapper[data-container="' + $reloadContainer.attr("id") + '"]').html()).css('pointer-events', 'auto');
				}
				$newContainerHtml.appendTo($reloadContainer);
				indi.app.blocks.common.initDOM($reloadContainer);
				indi.app.blocks.iCounter.initDOM($reloadContainer);
				indi.app.blocks.popupForm.initDOM($reloadContainer);
				indi.app.blocks.confirmAction.initDOM($reloadContainer);
				window.history.pushState("", "", url);
				loading.hide();
				$(window).trigger('changepos');
			}
		});
	};
	// обычная постраничка
	$(document).on("click", ".js-ajax-pagenation a", function (e) {
		var reloadContainerId = $(this).closest(".js-ajax-container").attr("id");
		if (!reloadContainerId) {
			reloadContainerId = $(this).closest('.js-ajax-pagenation-wrapper').attr("data-container");
		}
		var reloadContainerSelector = "#" + reloadContainerId;
		var url = $(this).attr("href");
		if (reloadContainerId) {
			indi.app.blocks.common.reloadContainer(url, reloadContainerSelector);
		}
		else {
			window.location.href = url;
		}
		e.stopPropagation();
		return false;
	});
	// показать еще
	$(document).on("click", ".js-ajax-pagenation-more a", function (e) {
		var reloadContainerId = $(this).closest(".js-ajax-container").attr("id");
		if (!reloadContainerId) {
			reloadContainerId = $(this).closest('.js-ajax-pagenation-wrapper').attr("data-container");
		}
		var reloadContainerSelector = "#" + reloadContainerId;
		var url = $(this).attr("href");
		$(this).css('pointer-events', 'none');
		if (reloadContainerId) {
			pager.reloadContainerShowMore(url, reloadContainerSelector);
		}
		else {
			window.location.href = url;
		}
		e.stopPropagation();
		return false;
	});
};
/**
 * Проверяет наличие блока "Ajax pager"
 *
 * @return boolean
 */
indi.app.blocks.pager.exists = function () {
	return $('.js-ajax-pagenation, .js-ajax-pagenation-more').length > 0;
};
/**
 * XXX: Блок шаблона "Загрузка фото с ресайзом"
 */

indi.app.blocks.fileResize = function () {
	$(document).on('change', '.js-file-resize input[type="file"]', function () {
		//При загрузке фото сохраняем файл на сервере
		var fd = new FormData();
		fd.append('file', $(this)[0].files[0]);
		fd.append('folder', "stories");
		$.ajax({
			url: '/ajax/images/saveUploadImage',
			data: fd,
			processData: false,
			contentType: false,
			type: 'POST',
			success: function (data) {
				//Проверяем, если фото подгружено не в первый раз, старое нужно удалить
				if ($('.js-imagerez').data('newimg') !== $('.js-imagerez').data('oldimg')) {
					var delId = $('.js-imagerez').attr('newimg');
				}
				var result = jQuery.parseJSON(data.data);
				//подставляем новую картинку пользователю
				$('.js-image-display').attr('src', result.image);
				$('.js-imagerez').attr('src', result.image);
				$('.js-imagerez').data('newimg', result.id);
				$('.cropper-container').find("img").attr('src', result.image);
				//Инициализируем кроппер
				$('.js-image-display').cropper({
					aspectRatio: 4 / 3,
					cropBoxMovable: true,
					cropBoxResizable: true,
					crop: function (e) {
					}
				});
				$(".js-image-display").cropper("reset");
				$('.cropper-container').show();
				$('.js-crop').css("display", "inline-block");
				$(".js-image-input").val(result.id);
				//Удаляем старое фото если нужно
				if (delId) {
					var fdd = new FormData();
					fdd.append('imageid', delId);
					$.ajax({
						url: '/ajax/images/deleteImage',
						data: fdd,
						processData: false,
						contentType: false,
						type: 'POST',
						success: function (data) {
						}
					});
				}
			}
		});
	});
	//По клику на обрезать сохраняем новый обрезанный файл
	$(document).on('click', '.js-crop', function (e) {
		e.stopPropagation();
		var cropBoxData = $(".js-image-display").cropper("getData");
		var croppedCanvas = $(".js-image-display").cropper("getData");
		var imgSrc = $(this).closest(".js-file-resize").find(".js-image-display").attr("src");
		var type = $(this).data("type");
		var imgID = $('.js-imagerez').data('newimg');
		var fd = new FormData();
		fd.append('width', cropBoxData.width);
		fd.append('height', cropBoxData.height);
		fd.append('x', cropBoxData.x);
		fd.append('y', cropBoxData.y);
		fd.append('img', imgSrc);
		fd.append('imgid', imgID);
		fd.append('type', type);
		$.ajax({
			url: '/ajax/images/cropImage/',
			data: fd,
			processData: false,
			contentType: false,
			type: 'POST',
			success: function (data) {
				var result = jQuery.parseJSON(data.data);
				$('.cropper-container').hide();
				$('.js-crop').css("display", "none");
				$('.js-imagerez').attr('src', result.image);
				$('.js-imagerez').data('newimg', result.id);
				$(".js-image-input").val(result.id).trigger('change');
			}
		});
	});
};
/**
 * Проверяет наличие блока "Загрузка фото с ресайзом"
 *
 * @return boolean
 */
indi.app.blocks.fileResize.exists = function () {
	return $('.js-file-resize').length > 0;
};
/**
 * XXX: Блок шаблона "Профиль пользователя"
 */
indi.app.blocks.userProfile = function () {
	//Сохранение обрезанного фото
	$(document).on('change', '.js-user-file', function () {
		var newId = $(this).val();
		var userIdValue = $("#user-id").val();
		$.post(
			'/ajax/images/saveUserPhoto/',
			{photoId: newId, userId: userIdValue},
			function (reponse) {
				$.post(
					window.location.href,
					function (response) {
						$("#user-profile").find('.js-file-resize').replaceWith(
							$(response).find('.js-file-resize')
						);
						indi.ui.init($("#user-profile"));
					}
				);
			}
		);
	});
};
/**
 * Проверяет наличие блока "Профиль пользователя"
 *
 * @return boolean
 */
indi.app.blocks.userProfile.exists = function () {
	return $('#user-profile').length > 0;
};
/**
 * Блок шаблона "Стандартный индикатор ajax-битрикса"
 */
indi.app.blocks.bitrixDefaultIndicator = function () {
	var lastWait = [];
	/* non-xhr loadings */
	BX.showWait = function (node, msg) {
		node = BX(node) || document.body || document.documentElement;
		msg = msg || BX.message('JS_CORE_LOADING');
		var container_id = node.id || Math.random();
		var obMsg = node.bxmsg = document.body.appendChild(BX.create('DIV', {
			props: {
				id: 'wait_' + container_id,
				className: 'bx-core-waitwindow'
			},
			text: msg
		}));
		var loading = new indi.ui.loading($(node));
		window.loading = loading;
		lastWait[lastWait.length] = obMsg;
		return obMsg;
	};
	BX.closeWait = function (node, obMsg) {
		window.loading.hide();
		if (node && !obMsg)
			obMsg = node.bxmsg;
		if (node && !obMsg && BX.hasClass(node, 'bx-core-waitwindow'))
			obMsg = node;
		if (node && !obMsg)
			obMsg = BX('wait_' + node.id);
		if (!obMsg)
			obMsg = lastWait.pop();
		if (obMsg && obMsg.parentNode) {
			for (var i = 0, len = lastWait.length; i < len; i++) {
				if (obMsg === lastWait[i]) {
					lastWait = BX.util.deleteFromArray(lastWait, i);
					break;
				}
			}
			obMsg.parentNode.removeChild(obMsg);
			if (node)
				node.bxmsg = null;
			BX.cleanNode(obMsg, true);
		}
	};
	BX.addCustomEvent('onAjaxSuccess', function () {
		indi.ui.widgets.init();
		indi.app.blocks.init();
		indi.app.blocks.common.initDOM();
	});
};
indi.app.blocks.bitrixDefaultIndicator.exists = function () {
	return $('.js-custom-indicator').length > 0;
};
/**
 * "Цели Yandex"
 */
indi.app.blocks.yandex = function () {

	//на клик
	$('body').on('click', '.js-ya-goal', function () {
		var goalVal;
		if (goalVal = $(this).data('goal')) {
			//yaCounter13809109.reachGoal(goalVal);
			console.log(goalVal);
		}
		return true;
	});
	//на загрузку
};
/**
 * Проверяет наличие страницы "Цели Yandex"
 *
 * @return boolean
 */
indi.app.blocks.yandex.exists = function () {
	return $('.js-ya-goal').length > 0;
};
/**
 * "Цели Google"
 */
indi.app.blocks.google = function () {

	//на клик
	$('body').on('click', '.js-ga-goal', function () {
		var category = $(this).data('category');
		var action = $(this).data('action');
		if (category && action) {
			//ga('send', 'event', category, action);
			//console.log(category);
			//console.log(action);
		}
		return true;
	});
	//на загрузку
};
/**
 * Проверяет наличие страницы "Цели Google"
 *
 * @return boolean
 */
indi.app.blocks.google.exists = function () {
	return $('.js-ga-goal').length > 0;
};
/**
 * XXX: Блок шаблона "Ссылка, открывающая форму во всплывающем окне"
 */

indi.app.blocks.popupForm = function () {
	/**
	 * Фокус на первое поле открытой формы
	 *
	 */
	var setFocus = function (modal) {
		setTimeout(function () {
			modal.find('input.form-control:first').focus();
		}, 500);
	};
	var showModal = function (link) {
		var id = link.data('modal-id');
		var modal = id ? $('#' + id) : null;
		if (modal === null) {
			return false;
		}
		modal = modal.find('.modal');
		if (!modal.data('modal-ready')) {
			modal.data('modal-ready', true);
			indi.ui.init(modal);
			//Обработчик отправки формы
			modal.on('submit', 'form', function () {
				$(this).find(':input[type="submit"]').prop('disabled', true);
				var loading = new indi.ui.loading(this);
				var form = $(this);
				var formData = new FormData($(form)[0]);
				$.ajax({
					url: form.attr('action'),
					type: 'post',
					processData: false,
					contentType: false,
					data: formData,
					success: function (response) {
						loading.hide();
						if ($(response).find(".js-redirect-url").length > 0) {
							var redirect = $(response).find(".js-redirect-url").val();
							window.location.href = redirect;
						}
						modal.find('.modal-body').replaceWith(
							$(response).find('.modal-body')
						);
						modal.find('.has-error:first :input:first').focus();
						indi.ui.init(modal);
					}
				});
				return false;
			});
			//Интеграция с HTML5-валидацией
			modal.on('click', 'form :input[type="submit"]', function () {
				$(this).closest('form').addClass('invalid');
			});
			//Закрытие по кнопке
			modal.on('click', '.btn-close', function () {
				modal.modal('hide');
			});
		}
		modal.modal({
			//backdrop: 'static'
		});
		setFocus(modal);
		return true;
	};
	var loadModal = function (link, callback) {
		var loading = new indi.ui.loading('body');
		$.get(
			link.data('href'),
			function (response) {
				loading.hide();
				var id = link.data('modal-id');
				if (!id) {
					id = indi.utils.getId('id');
					link.data('modal-id', id);
				}
				response = $('<div/>')
					.attr('id', id)
					.html(response);
				if (response.find('.modal').length === 0) {
					response.wrapInner(
						'<div class="modal fade bs-example-modal-md" tabindex="-1" role="dialog" aria-hidden="true">' +
						'	<div class="modal-dialog modal-md">' +
						'		<div class="modal-content">' +
						'			<div class="modal-body">' +
						'			</div>' +
						'		</div>' +
						'	</div>' +
						'</div>'
					);
				}
				response.appendTo('body');
				callback();
			}
		);
	};
	/**
	 * Инициализирует UI в заданном элементе DOM
	 *
	 * @param jQuery domElement DOM element
	 * @return void
	 */
	this.initDOM = function (domElement) {
		domElement.find('a.popup-form').each(function () {
			var link = $(this);
			link
			//Заменяем href, чтобы такие ссылки не открывались через контекстное меню "Открыть в новом окне"
				.data('href', link.attr('href'))
				.attr('href', 'javascript:;')
				//По click загружаем форму
				.click(function () {
					if (!showModal(link)) {
						loadModal(link, function () {
							showModal(link);
						});
					}
					return false;
				});
		});
	};
	//Обработчик инициализиации UI
	indi.ui.onInit(this.initDOM, this);
};

/**
 * Блок Количество на странице
 */
indi.app.blocks.listCount = function () {
	$('.js-list-count').on('change', function () {
		var val = $(this).val(),
			url = $(this).attr('data-url');
		url = url.replace(/%s/, val);
		window.location.href = url;
	});
};
/**
 * Проверяет наличие блока Количество на странице
 *
 * @return boolean
 */
indi.app.blocks.listCount.exists = function () {
	return $('.js-list-count').length > 0;
};
/**
 * Блок Сортировка на странице
 */
indi.app.blocks.sortField = function () {
	$('.js-sort-field').on('change', function () {
		window.location.href = $(this).val();
	});
};
/**
 * Проверяет наличие блока Сортировка на странице
 *
 * @return boolean
 */
indi.app.blocks.sortField.exists = function () {
	return $('.js-sort-field').length > 0;
};

/**
 * Блок загрузки файлов
 */
indi.app.blocks.dropFiles = function () {
	/**
	 * Пример разметки:
	 * <div class="js-fileinput-wrap">
	 *  <div class="form-group">
	 *    <div class="file-loading">
	 *      <input class="js-fileinput" name="input-id" type="file" data-max-count-files="5" required="required" data-upper-text="2222" data-bottom-text="required" multiple>
	 *    </div>
	 *    <div class="js-field-list-files">
	 *      <input class="form-control field-FILES" id="form-1-FILES" type="hidden" name="form_hidden_10" value="" required>
	 *    </div>
	 *  </div>
	 * </div>
	 *
	 * Возможные data-attr в HTML:
	 * data-max-count-files // максимальное количество загружаемых файлов за раз (появляется кнопка "добавить файл")
	 * data-min-count-files // минимальное количество загружаемых файлов за раз, если не указано, то приналичии аттрибута require устанавливается 1
	 * data-upper-text // изменяет верхний текст drag&drop
	 * data-bottom-text // изменяет нижний текст drag&drop
	 */
	this.initDOM = function (domElement) {
		// File input
		domElement.find('.js-fileinput-wrap').each(function () {
			var _this = $(this),
				input = _this.find('.js-fileinput'),
				form = _this.closest('form'),

				dataExtension = input.data('extension') ? [input.data('extension')] : null,
				dataFileTypes = dataExtension ? null : ['image', 'html', 'text', 'video', 'audio', 'flash', 'object'],
				dataMaxCounFiles = input.data('max-count-files'),
				dataMinCounFiles = input.data('min-count-files') || input.attr('required') ? 1 : null,
				dataUpperText = input.data('upper-text') || 'Перетащите файлы сюда …',
				dataBottomText = input.data('bottom-text') || '(Или щёлкните здесь, чтобы выбрать файл)';

			input.fileinput(
				$.extend({}, indi.fileInput.defaultSettings,
					{
						allowedFileTypes: dataFileTypes,
						allowedFileExtensions: dataExtension,
						minFileCount: dataMinCounFiles ? dataMinCounFiles : null,
						maxFileCount: dataMaxCounFiles ? dataMaxCounFiles : null,
						dropZoneTitle: '<div class="fileinput__title">' + dataUpperText + '</div>',
						dropZoneClickTitle: '<div class="fileinput__desc">' + dataBottomText + '</div>',
						showBrowse: dataMaxCounFiles > 1 // show browse button if max count of files more then 1
					}
				)
			).on('filebatchselected', function (event, files) {
				//input.fileinput("upload");
			}).on('fileuploaded', function (event, data, previewId, index) {
				//Вписываем в скрытое поле id загруженных файлов
				var form = $(this).parents('form:first');
				if (typeof(data.response.data.id) !== 'undefined') {
					var blockFiles = form.find('.js-field-list-files');
					var listIdFiles = blockFiles.find('input');
					listIdFiles.val(listIdFiles.val() + data.response.data.id + ';');
				}
				//после загрузки всех файлов отправляем форму
			}).on('filebatchuploadcomplete', function (event, files, extra) {
				//отправляем форму аяксом
				var form = $(this).parents('form:first');
				form.trigger('submitFileForm');
			});
			//перехватываем отправку формы
			//загружаем файлы после валидации формы
			form.on('submit', function () {
				if (input.fileinput('getFilesCount')) {
					input.fileinput('upload');
					return false;
				}
			});
		});
	};
	//Обработчик инициализиации UI
	indi.ui.onInit(this.initDOM, this);
};
/**
 * Проверяет наличие блока загрузки файлов
 *
 * @return boolean
 */
indi.app.blocks.dropFiles.exists = function () {
	return $('.js-fileinput-wrap').length > 0;
};

/**
 * AJAX обработка форм отправки
 */
indi.app.blocks.sendForm = function () {

	var block = this;
	this.send = function (form) {
		var $form = form;
		var formData = new FormData($form[0]);
		var container = $form.closest('.js-ajax-form');
		var containerId = container.attr('id');

		var loading = new indi.ui.loading();
		var action = container.data('action') ? container.data('action') : $form.attr('action');
		$.ajax({
			url: action,
			type: $form.attr('method'),
			processData: false,
			contentType: false,
			data: formData,
			success: function (result) {
				var html = $(result).find('#' + containerId).html();
				container.html(html);
				indi.app.blocks.common.initDOM(container);
				indi.app.blocks.init();
				indi.app.blocks.dropFiles.initDOM(container);
				loading.hide();
				var re = container.find('.g-recaptcha');
				if (re.length > 0) {
					var reId = re.attr('id');
					grecaptcha.render(reId, {
						'sitekey': container.find('.g-recaptcha').data('sitekey')
					});
				}
				if (container.find('.alert').length > 0) {
					$('html, body').animate({
						scrollTop: container.find('.alert').offset().top
					}, 'fast');
				}

			}
		});
		return false;
	};

	$('.js-ajax-form').on('submit', 'form', function (event) {
		block.send($(this));
		return false;
	});

	$('.js-ajax-form').on('submitFileForm', 'form', function (event) {
		block.send($(this));
		return false;
	});
};

/**
 * Проверяет наличие формы отправки
 *
 * @return boolean
 */
indi.app.blocks.sendForm.exists = function () {
	return $('.js-ajax-form').length > 0;
};

/**
 * Блок Диапазон дат
 */
indi.app.blocks.datepickerRange = function () {
	$('.datepicker[data-range]').on('change', function () {
		var picker = $("#" + $(this).data("range"));
		var setVal = $(this).data("set");
		if (setVal === undefined)
			setVal = "minDate";
		if (picker.length && this.value !== "") {
			var date = indi.app.locale.parse(this.value);
			if (date) {
				picker.datepicker("option", setVal, date);
			}
		}
	});
};
/**
 * Проверяет наличие блока Диапазон дат
 *
 * @return boolean
 */
indi.app.blocks.datepickerRange.exists = function () {
	return $('.datepicker[data-range]').length > 0;
};
/**
 * Блок ввода числа
 */
indi.app.blocks.iCounter = function () {
	this.initDOM = function (element) {
		// Input counter
		var iCounterPlanCnt = $('.js-counter-input', element);
		iCounterPlanCnt.each(function () {
			var _this = $(this),
				iCounter = $(this).closest('.js-counter-selector'),
				iCounterPlus = $('.js-counter-plus', iCounter),
				iCounterMinus = $('.js-counter-minus', iCounter),
				$val = parseInt($(this).val().replace(new RegExp('[^\\d]', 'ig'), ''));

			$(this).val($val >= 1 ? indi.utils.numberFormat($val, 0, '', ' ') : 1);
			$(this).on('change', function () {
				var $val = parseInt($(this).val().replace(new RegExp('[^\\d]', 'ig'), ''));
				$val = $val >= 1 ? $val : 1;
				$(this).val(indi.utils.numberFormat($val, 0, '', ' '));
			});
			iCounterPlus.unbind().on('click', function (e) {
				e.preventDefault();
				var $this = $(this),
					$parent = $this.closest('.js-counter-selector'),
					$input = $parent.find('.js-counter-input'),
					$val = $input.val().replace(new RegExp('[^\\d]', 'ig'), '');
				$val++;
				$input.val(indi.utils.numberFormat($val, 0, '', ' '));
				_this.trigger('change');
			});
			iCounterMinus.unbind().on('click', function (e) {
				e.preventDefault();
				var $this = $(this),
					$parent = $this.closest('.js-counter-selector'),
					$input = $parent.find('.js-counter-input'),
					$val = $input.val().replace(new RegExp('[^\\d]', 'ig'), '');
				$val--;
				$input.val(indi.utils.numberFormat($val, 0, '', ' '));
				_this.trigger('change');
			});
			$('.js-counter-selector').hover(function () {
					$(this).addClass('hover');
				},
				function () {
					$(this).removeClass('hover');
				}
			);
		});
	};
	//Обработчик инициализиации UI
	indi.ui.onInit(this.initDOM, this);
};
/**
 * Проверяет наличие блока ввода числа
 *
 * @return boolean
 */
indi.app.blocks.iCounter.exists = function () {
	return $('.js-counter-selector').length > 0;
};

/**
 * Блок множественного выбора
 */
indi.app.blocks.multDrop = function () {
	/**
	 * Инициализирует UI в заданном элементе DOM
	 *
	 * @param jQuery domElement DOM element
	 * @return void
	 */
	this.initDOM = function (domElement) {
		// Отмена закрытия bootstrap dropdown
		domElement.on("click.bs.dropdown.data-api", ".js-mult-drop.show", function (e) {
			e.stopPropagation();
		});
		// Checked counter
		domElement.find('.js-filter-count').on('change', function () {
			var inputChecked = $(this).is(':checked'),
				inputCount = $(this).closest('.mult-drop__list').find('.mult-drop__input:checked').length,
				countCheckedEl = $(this).closest('.mult-drop').find('.mult-drop__toggler-count');
			if (inputChecked) {
				$(this).parent().addClass('selected');
				$(this).closest('.mult-drop').addClass('active');
			} else {
				$(this).parent().removeClass('selected');
				$(this).closest('.mult-drop').removeClass('active');
			}
			if (inputCount) {
				countCheckedEl.css('display', 'inline-block').text(inputCount);
			} else {
				countCheckedEl.css('display', 'none');
			}
		});
	};
	//Обработчик инициализиации UI
	indi.ui.onInit(this.initDOM, this);
};
/**
 * Проверяет наличие блока множественного выбора
 *
 * @return boolean
 */
indi.app.blocks.multDrop.exists = function () {
	return $('.js-fileinput-wrap').length > 0;
};
/**
 * Блок Tab to Select
 */
indi.app.blocks.tabToSelect = function () {
	/**
	 * Инициализирует UI в заданном элементе DOM
	 *
	 * @param domElement jQuery DOM element
	 * @return void
	 */
	this.initDOM = function (domElement) {

		domElement.find('.js-tab-select').on('change', function () {
			var value = $(this).val();

			domElement.find('[data-toggle="tab"][href="' + value + '"]').trigger('click');
		});

		domElement.find('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {

			var target = $(e.target).attr('href'),
				select = $('.js-tab-select').find('option[value="' + target + '"]');

			select.parent().val(target).trigger('change');

			// Selectfix Fix
			select.closest('.selectfix-container')
				.find('.selectfix-current-value').text(select.text());
		});
	};

	//Обработчик инициализиации UI
	indi.ui.onInit(this.initDOM, this);
};

/**
 * Проверяет наличие блока Tab to Select
 *
 * @return boolean
 */
indi.app.blocks.tabToSelect.exists = function () {
	return $('.js-tab-select').length > 0;
};

/* Инициализация после готовности DOM */
$(function () {
	indi.init();
});